import api from "./baseApi";
import endpoints from "./endpoints";

export const getReportOptions=async()=>{
  const {data}=await api.get("/report/options");
  return data;
};

export const generateReport=async(payload)=>{
  const {data}=await api.post("/report/generate",payload);
  return data;
};

export const getReports=async(params={})=>{
  const {data}=await api.get("/report",{params});
  return data;
};

export const deleteReport=async(id)=>{
  const {data}=await api.delete(`/report/${id}`);
  return data;
};
